import {filter} from 'lodash';

import Loading from 'components/Loading';
import KyError from 'components/errors/KyError';
import useAppContext from 'conf/AppContext';
import {DataSource} from 'conf/enums';
import {useGet} from 'helpers/KyHooks';
import LabelAnnotationsBarChart from 'pages/LabelAnnotations/BarChart';

export default function LabelSection() {
  const appContext = useAppContext();

  const {response, error} = useGet('site/labelsByDrug', {
    cacheResponse: !appContext.isPreview,
  });

  let barChart = (
    <div className="laFigure laFigure--loading figure">
      <Loading />
    </div>
  );

  if (error) {
    barChart = <KyError kyError={error} />;
  } else if (response) {
    // noinspection JSNonASCIINames
    const data = filter(response.data, (drug) =>
      Object.keys(drug.labels).includes(DataSource.displayName['U.S. Food and Drug Administration'] ||
        DataSource.displayName['European Medicines Agency'] ||
        DataSource.displayName['Health Canada/Santé Canada'],
      ));
    
    barChart = (
      <LabelAnnotationsBarChart
        labelAnnotations={data}
        showSwissMedicAndPMDALabels={false}
      />
    );
  }

  return (
    <div id="section-la">
      <h3>Label Annotations</h3>
      {barChart}
    </div>
  );
}
